import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { MenuItem, FormControl, Select, InputLabel } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: 300,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    color: '#9C9C9C',
  },
  formControlBancos: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 200,
    maxWidth: 350,
    width: 350,
  },
  formControlTipoTributo: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 120,
    maxWidth: 250,
    width: 300,
  },
  span: {
    width: '100%',
    color: '#757575',
  },
  sizeFont: {
    fontSize: 14,
  },
}));


// 1 - Automatic Debit Register
// 2 - Manager Consultation

export default function SelectItem(props) {
  const classes = useStyles();
  const [values, setValues] = React.useState({
    age: '',
    tipoTributo: '',
    codigoBanco: '',
  });

  const { clearAll, codigoBancoSelecionado } = { ...props }

  useEffect(() => {
    if (clearAll) {
      setValues('');
    }
  }, [clearAll])

  useEffect(() => {
    setValues(state => ({
      ...state,
      codigoBanco: codigoBancoSelecionado,
    }));
  }, [codigoBancoSelecionado])

  //  const [setLabelWidth] = React.useState(0);
  // React.useEffect(() => {
  //   setLabelWidth(inputLabel.current.offsetWidth);
  // }, []);

  function handleChange(event) {
    setValues(oldValues => ({
      ...oldValues,
      [event.target.name]: event.target.value,
    }));

    if (props.typeSelect === 1 ||props.typeSelect === 4 ) {
      props.getBankCode(event.target.value)
    } else if (props.typeSelect === 2) {
      props.getSelectedTribute(event.target.value)
    }

  }

  return (
    <form className={classes.root} autoComplete="off">

      {props.typeSelect === 1 && (

        <FormControl className={classes.formControlBancos}>
          <InputLabel>BANCO*</InputLabel>
          <Select
            value={values.codigoBanco}
            onChange={handleChange}
            displayEmpty
            disabled={props.disabled}
            inputProps={{
              name: 'codigoBanco',
              id: 'ddlBanco',
            }}
          >
          <MenuItem value="" disabled>Selecione</MenuItem>
            {props.banks.map(item => {
              return (
                <MenuItem key={item.CodigoBanco} value={item.CodigoBanco}>{item.Descricao}</MenuItem>
              )
            }
            )}
          </Select>
        </FormControl>

      )}
      {props.typeSelect === 4 && (

        <FormControl className={classes.formControlBancos}>
          <span className={clsx(classes.span, classes.sizeFont)}>BANCO*</span>
          <Select
            value={values.codigoBanco}
            onChange={handleChange}
            displayEmpty
            disabled={props.disabled}
            inputProps={{
              name: 'codigoBanco',
              id: 'ddlBanco',
            }}
          >
          <MenuItem value="">Selecione</MenuItem>
            {props.banks.map(item => {
              return (
                <MenuItem key={item.CodigoBanco} value={item.CodigoBanco}>{item.Descricao}</MenuItem>
              )
            }
            )}
          </Select>
        </FormControl>

      )}

      {props.typeSelect === 2 && (
        <FormControl className={classes.formControlTipoTributo}>
          <span className={clsx(classes.span, classes.sizeFont)}>TRIBUTO</span>
          <Select
            disabled={props.optionsList.length > 0 ? false : true}
            value={values.tipoTributo}
            onChange={handleChange}
            displayEmpty
            // className={classes.selectEmpty}
            inputProps={{
              name: 'tipoTributo',
              id: 'ddlTipoTributo',
            }}
          >            
          <MenuItem value="">Selecione</MenuItem>
            {props.optionsList.map((tipoTributo, index) =>
              <MenuItem key={index} value={tipoTributo}>{tipoTributo.DescricaoTributo}</MenuItem>
            )}
          </Select>
        </FormControl>
      )}

      {props.typeSelect === 3 && (

        <FormControl className={classes.formControlTipoTributo}>
          <span className={clsx(classes.span, classes.sizeFont)}>SITUAÇÃO</span>
          <Select
            value={values.age}
            onChange={handleChange}
            inputProps={{
              name: 'age2',
              id: 'age-simple2',
            }}
          >
            {/* <MenuItem value="">
              <em>None</em>
              </MenuItem> */}
            <MenuItem value={''}>Todos</MenuItem>
            <MenuItem value={2}>Vincendos</MenuItem>
            <MenuItem value={3}>Vencidos</MenuItem>
            <MenuItem value={4}>Exigibilidade Suspensa</MenuItem>
          </Select>
        </FormControl>

      )}



    </form>
  );
}
